"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerDataT = exports.TrackerData = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const stay_aligned_tracker_js_1 = require("../../../solarxr-protocol/data-feed/stay-aligned/stay-aligned-tracker.js");
const tracker_info_js_1 = require("../../../solarxr-protocol/data-feed/tracker/tracker-info.js");
const temperature_js_1 = require("../../../solarxr-protocol/datatypes/temperature.js");
const tracker_id_js_1 = require("../../../solarxr-protocol/datatypes/tracker-id.js");
const tracker_status_js_1 = require("../../../solarxr-protocol/datatypes/tracker-status.js");
const quat_js_1 = require("../../../solarxr-protocol/datatypes/math/quat.js");
const vec3f_js_1 = require("../../../solarxr-protocol/datatypes/math/vec3f.js");
/**
 * Describes all possible information about a tracker. A tracker is anything that
 * provides kinematic data about a particular body part.
 *
 * Trackers may be synthetic/computed or instead part of an actual hardware device.
 * There can be multiple trackers per hardware device.
 */
class TrackerData {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTrackerData(bb, obj) {
        return (obj || new TrackerData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTrackerData(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TrackerData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    trackerId(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new tracker_id_js_1.TrackerId()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    info(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new tracker_info_js_1.TrackerInfo()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    status() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : tracker_status_js_1.TrackerStatus.NONE;
    }
    /**
     * Sensor rotation after fusion
     */
    rotation(obj) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? (obj || new quat_js_1.Quat()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * Position, in meters
     */
    position(obj) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? (obj || new vec3f_js_1.Vec3f()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * Raw angular velocity, in euler angles, rad/s
     */
    rawAngularVelocity(obj) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? (obj || new vec3f_js_1.Vec3f()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * Raw acceleration, in m/s^2
     */
    rawAcceleration(obj) {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? (obj || new vec3f_js_1.Vec3f()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * Temperature, in degrees celsius
     */
    temp(obj) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? (obj || new temperature_js_1.Temperature()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * Acceleration without gravity, in m/s^2
     */
    linearAcceleration(obj) {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? (obj || new vec3f_js_1.Vec3f()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * Reference-adjusted rotation for IMU-only trackers (VR HMD yaw is used as a reset reference).
     * In other words, a rotation that is aligned to a reliable source of rotation ((0, VR HMD YAW, 0)),
     * triggered after user input (using reset buttons).
     * This is a SlimeVR-specific field and computed exclusively by SlimeVR server.
     * Includes: mounting orientation, full, quick and mounting reset adjustments.
     * This rotation can be used to reconstruct a skeleton pose using forward kinematics.
     */
    rotationReferenceAdjusted(obj) {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? (obj || new quat_js_1.Quat()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * Zero-reference-adjusted rotation for IMU-only trackers (identity quaternion is used as a reset reference).
     * In other words, a rotation that is aligned to a zero vector ((0, 0, 0)) by
     * inverting the current rotation, triggered after user input (using reset buttons).
     * This is a SlimeVR-specific field and computed exclusively by SlimeVR server.
     * Includes: only full and quick reset adjustments.
     * This rotation can be used in visualizations for IMU debugging.
     */
    rotationIdentityAdjusted(obj) {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? (obj || new quat_js_1.Quat()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * Data ticks per second, processed by SlimeVR server
     */
    tps() {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : null;
    }
    /**
     * Magnetic field vector, in mGauss
     */
    rawMagneticVector(obj) {
        const offset = this.bb.__offset(this.bb_pos, 28);
        return offset ? (obj || new vec3f_js_1.Vec3f()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * Stay Aligned
     */
    stayAligned(obj) {
        const offset = this.bb.__offset(this.bb_pos, 30);
        return offset ? (obj || new stay_aligned_tracker_js_1.StayAlignedTracker()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startTrackerData(builder) {
        builder.startObject(14);
    }
    static addTrackerId(builder, trackerIdOffset) {
        builder.addFieldOffset(0, trackerIdOffset, 0);
    }
    static addInfo(builder, infoOffset) {
        builder.addFieldOffset(1, infoOffset, 0);
    }
    static addStatus(builder, status) {
        builder.addFieldInt8(2, status, tracker_status_js_1.TrackerStatus.NONE);
    }
    static addRotation(builder, rotationOffset) {
        builder.addFieldStruct(3, rotationOffset, 0);
    }
    static addPosition(builder, positionOffset) {
        builder.addFieldStruct(4, positionOffset, 0);
    }
    static addRawAngularVelocity(builder, rawAngularVelocityOffset) {
        builder.addFieldStruct(5, rawAngularVelocityOffset, 0);
    }
    static addRawAcceleration(builder, rawAccelerationOffset) {
        builder.addFieldStruct(6, rawAccelerationOffset, 0);
    }
    static addTemp(builder, tempOffset) {
        builder.addFieldStruct(7, tempOffset, 0);
    }
    static addLinearAcceleration(builder, linearAccelerationOffset) {
        builder.addFieldStruct(8, linearAccelerationOffset, 0);
    }
    static addRotationReferenceAdjusted(builder, rotationReferenceAdjustedOffset) {
        builder.addFieldStruct(9, rotationReferenceAdjustedOffset, 0);
    }
    static addRotationIdentityAdjusted(builder, rotationIdentityAdjustedOffset) {
        builder.addFieldStruct(10, rotationIdentityAdjustedOffset, 0);
    }
    static addTps(builder, tps) {
        builder.addFieldInt16(11, tps, 0);
    }
    static addRawMagneticVector(builder, rawMagneticVectorOffset) {
        builder.addFieldStruct(12, rawMagneticVectorOffset, 0);
    }
    static addStayAligned(builder, stayAlignedOffset) {
        builder.addFieldOffset(13, stayAlignedOffset, 0);
    }
    static endTrackerData(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new TrackerDataT((this.trackerId() !== null ? this.trackerId().unpack() : null), (this.info() !== null ? this.info().unpack() : null), this.status(), (this.rotation() !== null ? this.rotation().unpack() : null), (this.position() !== null ? this.position().unpack() : null), (this.rawAngularVelocity() !== null ? this.rawAngularVelocity().unpack() : null), (this.rawAcceleration() !== null ? this.rawAcceleration().unpack() : null), (this.temp() !== null ? this.temp().unpack() : null), (this.linearAcceleration() !== null ? this.linearAcceleration().unpack() : null), (this.rotationReferenceAdjusted() !== null ? this.rotationReferenceAdjusted().unpack() : null), (this.rotationIdentityAdjusted() !== null ? this.rotationIdentityAdjusted().unpack() : null), this.tps(), (this.rawMagneticVector() !== null ? this.rawMagneticVector().unpack() : null), (this.stayAligned() !== null ? this.stayAligned().unpack() : null));
    }
    unpackTo(_o) {
        _o.trackerId = (this.trackerId() !== null ? this.trackerId().unpack() : null);
        _o.info = (this.info() !== null ? this.info().unpack() : null);
        _o.status = this.status();
        _o.rotation = (this.rotation() !== null ? this.rotation().unpack() : null);
        _o.position = (this.position() !== null ? this.position().unpack() : null);
        _o.rawAngularVelocity = (this.rawAngularVelocity() !== null ? this.rawAngularVelocity().unpack() : null);
        _o.rawAcceleration = (this.rawAcceleration() !== null ? this.rawAcceleration().unpack() : null);
        _o.temp = (this.temp() !== null ? this.temp().unpack() : null);
        _o.linearAcceleration = (this.linearAcceleration() !== null ? this.linearAcceleration().unpack() : null);
        _o.rotationReferenceAdjusted = (this.rotationReferenceAdjusted() !== null ? this.rotationReferenceAdjusted().unpack() : null);
        _o.rotationIdentityAdjusted = (this.rotationIdentityAdjusted() !== null ? this.rotationIdentityAdjusted().unpack() : null);
        _o.tps = this.tps();
        _o.rawMagneticVector = (this.rawMagneticVector() !== null ? this.rawMagneticVector().unpack() : null);
        _o.stayAligned = (this.stayAligned() !== null ? this.stayAligned().unpack() : null);
    }
}
exports.TrackerData = TrackerData;
class TrackerDataT {
    constructor(trackerId = null, info = null, status = tracker_status_js_1.TrackerStatus.NONE, rotation = null, position = null, rawAngularVelocity = null, rawAcceleration = null, temp = null, linearAcceleration = null, rotationReferenceAdjusted = null, rotationIdentityAdjusted = null, tps = null, rawMagneticVector = null, stayAligned = null) {
        this.trackerId = trackerId;
        this.info = info;
        this.status = status;
        this.rotation = rotation;
        this.position = position;
        this.rawAngularVelocity = rawAngularVelocity;
        this.rawAcceleration = rawAcceleration;
        this.temp = temp;
        this.linearAcceleration = linearAcceleration;
        this.rotationReferenceAdjusted = rotationReferenceAdjusted;
        this.rotationIdentityAdjusted = rotationIdentityAdjusted;
        this.tps = tps;
        this.rawMagneticVector = rawMagneticVector;
        this.stayAligned = stayAligned;
    }
    pack(builder) {
        const trackerId = (this.trackerId !== null ? this.trackerId.pack(builder) : 0);
        const info = (this.info !== null ? this.info.pack(builder) : 0);
        const stayAligned = (this.stayAligned !== null ? this.stayAligned.pack(builder) : 0);
        TrackerData.startTrackerData(builder);
        TrackerData.addTrackerId(builder, trackerId);
        TrackerData.addInfo(builder, info);
        TrackerData.addStatus(builder, this.status);
        TrackerData.addRotation(builder, (this.rotation !== null ? this.rotation.pack(builder) : 0));
        TrackerData.addPosition(builder, (this.position !== null ? this.position.pack(builder) : 0));
        TrackerData.addRawAngularVelocity(builder, (this.rawAngularVelocity !== null ? this.rawAngularVelocity.pack(builder) : 0));
        TrackerData.addRawAcceleration(builder, (this.rawAcceleration !== null ? this.rawAcceleration.pack(builder) : 0));
        TrackerData.addTemp(builder, (this.temp !== null ? this.temp.pack(builder) : 0));
        TrackerData.addLinearAcceleration(builder, (this.linearAcceleration !== null ? this.linearAcceleration.pack(builder) : 0));
        TrackerData.addRotationReferenceAdjusted(builder, (this.rotationReferenceAdjusted !== null ? this.rotationReferenceAdjusted.pack(builder) : 0));
        TrackerData.addRotationIdentityAdjusted(builder, (this.rotationIdentityAdjusted !== null ? this.rotationIdentityAdjusted.pack(builder) : 0));
        if (this.tps !== null)
            TrackerData.addTps(builder, this.tps);
        TrackerData.addRawMagneticVector(builder, (this.rawMagneticVector !== null ? this.rawMagneticVector.pack(builder) : 0));
        TrackerData.addStayAligned(builder, stayAligned);
        return TrackerData.endTrackerData(builder);
    }
}
exports.TrackerDataT = TrackerDataT;
